/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiSearchByNameRetrieveParams } from './model/apiSearchByNameRetrieveParams';
import type { NameSearchResponse } from './model/nameSearchResponse';

/**
 * Search providers by partial name within a geographic bounding box.
 */
export const apiSearchByNameRetrieve = (
  params: ApiSearchByNameRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<NameSearchResponse>({
    url: `/api/v7/search-by-name/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiSearchByNameRetrieveQueryKey = (params?: ApiSearchByNameRetrieveParams) => {
  return [`/api/v7/search-by-name/`, ...(params ? [params] : [])] as const;
};

export const getApiSearchByNameRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSearchByNameRetrieve>>,
  TError = ErrorType<unknown>
>(
  params: ApiSearchByNameRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSearchByNameRetrieve>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSearchByNameRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchByNameRetrieve>>> = ({
    signal,
  }) => apiSearchByNameRetrieve(params, signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiSearchByNameRetrieve>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiSearchByNameRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchByNameRetrieve>>
>;
export type ApiSearchByNameRetrieveQueryError = ErrorType<unknown>;

export function useApiSearchByNameRetrieve<
  TData = Awaited<ReturnType<typeof apiSearchByNameRetrieve>>,
  TError = ErrorType<unknown>
>(
  params: ApiSearchByNameRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSearchByNameRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSearchByNameRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
